<template>
  <NuxtLink to="/" class="flex flex-row items-center logo-font">
    <p class="text-sky-500 text-4xl">//</p>
    <p class="text-white text-xl tracking-widest">TurboWeb</p>
  </NuxtLink>
</template>
<style>
.logo-font {
  font-family: "Bangers", cursive;
}
</style>
